import { render, staticRenderFns } from "./SimpleExamModelFilter.vue?vue&type=template&id=6c31d2d8&"
import script from "./SimpleExamModelFilter.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports